import axios from "@/lib/axios";

export type CreateResourceFileRequestParams = {
  companyId: string;
  resourceLibraryId: string;
  file: File;
  name: string;
  description?: string;
  tags?: string[];
};

export type CreateResourceFileResponse = { id: string };

export const createResourceFile = (params: CreateResourceFileRequestParams) => {
  const formData = new FormData();

  formData.append("file", params.file);
  formData.append(
    "request",
    new Blob(
      [
        JSON.stringify({
          name: params.name,
          description: params.description,
          tags: params.tags,
        }),
      ],
      { type: "application/json" },
    ),
  );

  return axios
    .post<CreateResourceFileResponse>(
      `/v1/companies/${params.companyId}/resource-libraries/${params.resourceLibraryId}/resources/file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    )
    .then((res) => res.data);
};
